import React from 'react';
import type { CrmMoveLog } from '../../services/CrmAutomationService';
import {
  formatConfidence,
  formatDateTime,
  isAiTrigger,
  moveHeadline,
  moveRouteLabel,
  truncateText,
} from '../../utils/crmMoveLabels';
import './crmFunnel.css';

export const EVIDENCE_MAX_CHARS = 90;

export function cardMoveTooltip(move: CrmMoveLog): string {
  const lines: string[] = [];
  const route = moveRouteLabel(move);
  if (route) lines.push(route);
  if (move.detail?.trim()) lines.push(`Motivo: ${move.detail.trim()}`);
  if (move.evidence?.trim()) lines.push(`Evidência: “${move.evidence.trim()}”`);
  const conf = formatConfidence(move.confidence);
  if (conf) lines.push(`Confiança: ${conf}`);
  const when = formatDateTime(move.createdAt);
  if (when) lines.push(when);
  return lines.join('\n');
}

/** Selo compacto no card do Kanban: última movimentação aplicada (IA ou pessoa) e a evidência. */
const CardMoveBadge: React.FC<{ move?: CrmMoveLog | null; tone?: 'dark' | 'light' }> = ({ move, tone = 'dark' }) => {
  if (!move || (move.outcome && move.outcome !== 'moved')) return null;
  const evidence = truncateText(move.evidence, EVIDENCE_MAX_CHARS);
  const ai = isAiTrigger(move.triggerType);
  return (
    <div
      className={`crm-move-badge crm-move-badge--${tone} ${ai ? 'is-ai' : 'is-human'}`}
      title={cardMoveTooltip(move)}
      data-testid="card-move-badge"
    >
      <span className="crm-move-badge__head">{moveHeadline(move)}</span>
      {evidence && <span className="crm-move-badge__quote">“{evidence}”</span>}
    </div>
  );
};

export default CardMoveBadge;
